// COMPONENT
import HeaderComponent from "../components/Header"
import MenuComponent from "../components/SideMenu"
import BreadcrumbComponent from "../components/Breadcrumb"

// LIBRARY
import Swal from "sweetalert2"
import { toast } from "react-toastify"
import Cookies from "universal-cookie"
import ReactLoading from "react-loading"
import React, { Component } from "react"
import Pagination from "react-js-pagination"
import DateRangePicker from "react-bootstrap-daterangepicker"

// CSS
import "../components/css/style.css"
import "../components/css/bootstrap.css"
import "bootstrap-daterangepicker/daterangepicker.css"

const cookies = new Cookies()
toast.configure()

let month_array = [
  "",
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
]
export default class InAndOutWardScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      modal_detail: false,
      modal_filter: false,
      search: false,

      token: cookies.get("token") ? "token " + cookies.get("token") : "",

      filter_start_date:
        new Date(
          new Date().setFullYear(new Date().getFullYear() - 1)
        ).getFullYear() +
        "-" +
        ("00" + (new Date().getMonth() + 1)).slice(-2) +
        "-" +
        ("00" + new Date().getDate()).slice(-2),
      filter_end_date:
        new Date().getFullYear() +
        "-" +
        ("00" + (new Date().getMonth() + 1)).slice(-2) +
        "-" +
        ("00" + new Date().getDate()).slice(-2),
      filter_project: "all",
      filter_agency: "all",
      filter_status: "all",
      filter_type: "all",

      data_search: "",

      data: null,
      detail: null,
      project: cookies.get("user_profile").agency_list || null,
      agency: null,

      index: 0,
      page: 1,
      profile: null,
    }
  }
  componentDidMount() {
    const {project} = this.state;
    this.GET()
    var user = cookies.get("user_profile")
    if (user?.role_data?.role_name === "system_admin") {
      this.GETProject()
    } else {
      this.setState({
        project: [...project,{
        agency_id: cookies.get("user_profile").agency_id,
        agency_name: cookies.get("user_profile").agency_name,
        project_id: cookies.get("user_profile").project_id,
        project_name: cookies.get("user_profile").project_name,
      }]
      })
    }
  }

  GET() {
    const {page, token} = this.state;
    this.setState({ loading: true })
    fetch(
      global.api + "v1/in-out-ward/on-web/page/" + page,
      {
        method: "GET",
        headers: { "Content-Type": "application/json", accept: "application/json", Authorization: token },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ data: result.data, loading: false })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ data: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  GETProject() {
    const {token} = this.state;
    this.setState({ loading: true })
    fetch(global.api + "v1/project/all", {
      method: "GET",
      headers: { "Content-Type": "application/json", accept: "application/json", Authorization: token }
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ project: result.data.data, loading: false })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ project: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  GETAgency() {
    const {token, filter_project} = this.state;
    this.setState({ loading: true })
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", accept: "application/json", Authorization: token },
      body: JSON.stringify({ project_id: filter_project }),
    }
    fetch(global.api + "v1/project/agency", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ agency: result.data.data, loading: false })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ agency: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  GETDetail(date, time, index) {
    const {token} = this.state;
    this.setState({ loading: true, index: index })

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    }
    fetch(
      global.api + "v1/in-out-ward/date-time/" + date + "/" + time,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ detail: result.data.data[0], loading: false, modal_detail: true })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ data: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  filter() {
    const {token, page, filter_status, filter_start_date, filter_end_date, filter_project, filter_agency, filter_type} = this.state;
    this.setState({ loading: true, filter: true })
    let status = filter_status === "1" ? 1: filter_status === "2"? 2 : "all"

    fetch(
      global.api + "v1/in-out-ward/on-web/filter/page/" + page,
      {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        start_date: filter_start_date,
        end_date: filter_end_date,
        project_id: filter_project,
        agency_id: filter_agency,
        visitor_type: filter_type,
        status: status,
      }),
    }
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ data: result.data, loading: false })
        } else {
          switch (result.data.message) {
            case "This Page is not available":
              this.alert("info", "แจ้งเตือน", "ไม่พบหน้า")
              break
            default:
              this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  search() {
    const {token, data_search, page} = this.state;
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        data_search: data_search,
      }),
    }
    fetch(
      global.api + "v1/in-out-ward/on-web/search/page/" + page,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          if (result.data.data.length === 0) {
            this.alert("info", "แจ้งเตือน", "ค้นหาไม่พบ")
            this.setState({ data_search: "", loading: false })
          } else {
            this.setState({ data: result.data, loading: false })
          }
        } else {
          switch (result.data.message) {
            case "This Page is not available":
              this.alert("info", "แจ้งเตือน", "ไม่พบหน้า")
              break
            default:
              this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  alert(icon, title, detail) {
    Swal.fire({
      icon: icon,
      title: title,
      text: detail,
      confirmButtonText: "ตกลง",
    })
  }

  handlePageChange(pageNumber) {
    const {search, filter} = this.state;
    this.setState({ page: pageNumber })
    if (search) {
      this.search()
    } else if (filter) {
      this.filter()
    } else {
      this.GET()
    }
  }

  clear_form() {
    this.setState({
      loading: false,
      modal_detail: false,
    })
  }

  render() {
    const {loading, data_search, modal_filter, filter_project, filter_agency, filter_status, filter_type, data, project, agency, page, modal_detail, detail, modal_profile, profile} = this.state;
    return (
      <div className="full bg-contain">
        {loading && (
          <div className="loading">
            <ReactLoading
              type={"spinningBubbles"}
              color="#fff"
              height={48}
              width={48}
            />
          </div>
        )}
        <div className="menu-container">
          <MenuComponent />
          <div className="w-100">
            <BreadcrumbComponent page1="เข้า-ออกวอร์ด" page2="" />
            <HeaderComponent header="เข้า-ออกวอร์ด" report="true" />
            {/* เมนู ฟิลเตอร์  */}
            <div className="bg-gray px-3 pt-3 w-100">
              <div className="row d-flex mx-0 justify-content-between">
                <div className="d-flex row mx-0">
                  {/* ค้นหา */}
                  <div className="mx-2 mb-3">
                    <input
                      className="form-control bg-white"
                      type="search"
                      placeholder="เลขที่บัตร, ชื่อ, หมายเลขห้อง"
                      value={data_search}
                      onChange={(e) => {
                        this.setState({ data_search: e.target.value })
                        if (e.target.value === "") {
                          this.setState({
                            page: 1,
                            filter_project: "all",
                            filter_agency: "all",
                            filter_status: "all",
                            filter_type: "all",
                            search: false,
                            filter: false,
                          })
                          setTimeout(() => {
                            this.GET()
                          }, 10)
                        }
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          this.setState({
                            page: 1,
                            filter_project: "all",
                            filter_agency: "all",
                            filter_status: "all",
                            filter_type: "all",
                            search: true,
                          })
                          setTimeout(() => {
                            this.search()
                          }, 10)
                        }
                      }}
                    ></input>
                  </div>
                  <div className="line-primary"></div>
                  {/* วันเริ่มต้น - สิ้นสุด */}
                  <div className="mx-2 mb-3 w-250px">
                    <DateRangePicker
                      initialSettings={{
                        startDate: new Date(
                          new Date().setFullYear(new Date().getFullYear())
                        ),
                        endDate: new Date(),
                        locale: {
                          format: "DD/MM/YYYY",
                        },
                      }}
                      onApply={(e) => {
                        let value = e.target.value
                        let start = value.split(" - ")[0]
                        let end = value.split(" - ")[1]
                        let startdate =
                          start.split("/")[2] +
                          "-" +
                          start.split("/")[1] +
                          "-" +
                          start.split("/")[0]
                        let enddate =
                          end.split("/")[2] +
                          "-" +
                          end.split("/")[1] +
                          "-" +
                          end.split("/")[0]

                        this.setState({
                          filter_agency: "all",
                          filter_project: "all",
                          filter_status: "all",
                          filter_type: "all",
                          page: 1,
                          search: false,
                          data_search: "",
                          filter_start_date: startdate,
                          filter_end_date: enddate,
                        })
                        setTimeout(() => {
                          this.filter()
                        }, 10)
                      }}
                    >
                      <input type="text" className="form-control " />
                    </DateRangePicker>
                  </div>
                </div>
                <div className="d-flex row mx-0">
                  {/* ตัวกรองโครงการ */}
                  <div className="mx-2 mb-3">
                    <button
                      className="btn btn-outline-primary bg-white "
                      onClick={() => {
                        this.setState({ modal_filter: true })
                      }}
                    >
                      <span className="icon mr-2">{"\uf1de"}</span>
                      ตัวกรองโครงการ
                    </button>
                    <div
                      class={modal_filter ? "bg-modal" : ""}
                      onClick={() => {
                        this.setState({ modal_filter: false })
                      }}
                    ></div>
                    {/* modal */}
                    <div
                      class={
                        modal_filter
                          ? "card border-0 modal-filter p-3 mt-3"
                          : "d-none"
                      }
                    >
                      {/* โครงการ */}
                      <div class="row my-2">
                        <div class="col-4">โครงการ:</div>
                        <div class="col-8">
                          <select
                            className="form-control"
                            value={filter_project}
                            onChange={(e) => {
                              this.setState({
                                filter_project: e.target.value,
                                filter_agency: "all",
                              })
                              setTimeout(() => {
                                this.GETAgency()
                              }, 20)
                            }}
                          >
                            <option value="all" selected disabled>
                              -- เลือกโครงการ --
                            </option>
                            {project &&
                              project.map((item, index) => (
                                <option value={item.project_id} key={index}>
                                  {item.project_name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      {/* หน่วยงาน */}
                      <div class="row my-2">
                        <div class="col-4">หน่วยงาน:</div>
                        <div class="col-8">
                          <select
                            className="form-control"
                            value={filter_agency}
                            onChange={(e) => {
                              this.setState({ filter_agency: e.target.value })
                            }}
                          >
                            <option value="all" selected disabled>
                              -- เลือกหน่วยงาน --
                            </option>
                            {agency &&
                              agency.map((item, index) => (
                                <option value={item.agency_id} key={index}>
                                  {item.agency_name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <hr class="my-1" />
                      {/* ปุ่ม */}
                      <div class="row my-2">
                        <div class="col-4"></div>
                        <div class="col-8 d-flex">
                          <button
                            className="btn btn-secondary mr-2 w-50"
                            onClick={() => {
                              this.setState({
                                filter_agency: "all",
                                filter_project: "all",
                                filter_status: "all",
                                filter_type: "all",
                                page: 1,
                                search: false,
                                filter: false,
                                data_search: "",
                                filter_start_date:
                                  new Date(
                                    new Date().setFullYear(
                                      new Date().getFullYear() - 1
                                    )
                                  ).getFullYear() +
                                  "-" +
                                  ("00" + (new Date().getMonth() + 1)).slice(
                                    -2
                                  ) +
                                  "-" +
                                  ("00" + new Date().getDate()).slice(-2),
                                filter_end_date:
                                  new Date().getFullYear() +
                                  "-" +
                                  ("00" + (new Date().getMonth() + 1)).slice(
                                    -2
                                  ) +
                                  "-" +
                                  ("00" + new Date().getDate()).slice(-2),
                              })

                              setTimeout(() => {
                                this.GET()
                              }, 10)

                              this.setState({
                                modal_filter: false,
                              })
                            }}
                          >
                            รีเซ็ท
                          </button>
                          <button
                            className="btn btn-primary ml-2 w-50"
                            onClick={() => {
                              this.setState({
                                filter_status: "",
                                filter_visitor: "",
                                page: 1,
                                data_search: "",
                                search: false,
                              })

                              setTimeout(() => {
                                this.filter()
                              }, 10)

                              this.setState({
                                modal_filter: false,
                              })
                            }}
                          >
                            <span className="icon mr-2">{"\uf1de"}</span>
                            ยืนยัน
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* สถานะ */}
                  <div className="mx-2 mb-3">
                    <select
                      className="form-control"
                      value={filter_status}
                      onChange={(e) => {
                        this.setState({
                          filter_status: e.target.value,
                          page: 1,
                          data_search: "",
                          search: false,
                        })
                        setTimeout(() => {
                          this.filter()
                        }, 10)
                      }}
                    >
                      <option value="all" selected>
                        แสดงทุกสถานะ
                      </option>
                      <option value="1">อยู่ในพื้นที่</option>
                      <option value="2">ออกนอกพื้นที่</option>
                    </select>
                  </div>
                  {/* ประเภท */}
                  <div className="mx-2 mb-3">
                    <select
                      className="form-control"
                      value={filter_type}
                      onChange={(e) => {
                        this.setState({
                          filter_type: e.target.value,
                          page: 1,
                          data_search: "",
                          search: false,
                        })
                        setTimeout(() => {
                          this.filter()
                        }, 10)
                      }}
                    >
                      <option value="all" selected>
                        แสดงทุกประเภท
                      </option>
                      <option value="visit">เยี่ยม</option>
                      <option value="vigil">เฝ้า</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* ตาราง */}
            {data &&
            data.data &&
            data.data.length === 0 ? (
              <div className="w-100  p-3">
                <div className="table-responsive">
                  <table className="table design-table">
                    <thead>
                      <tr>
                        <th className="text-left">วันเวลานำเข้า</th>
                        <th className="text-left ">เลขที่บัตร</th>
                        <th className="text-left">ประเภท</th>
                        <th className="text-left">หมายเลขห้อง</th>
                        <th className="text-left">วันเวลาเข้า</th>
                        <th className="text-left">วันเวลาออก</th>
                        <th className="text-center w-150px">สถานะ</th>
                        <th className="text-center">รายละเอียด</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={8} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="w-100 p-3 ">
                <div className="table-responsive">
                  <table className="table design-table">
                    <thead>
                      <tr>
                        <th className="text-left">วันเวลานำเข้า</th>
                        <th className="text-left">เลขที่บัตร</th>
                        <th className="text-left">ประเภท</th>
                        <th className="text-left">หมายเลขห้อง</th>
                        <th className="text-left">วันเวลาเข้า</th>
                        <th className="text-left">วันเวลาออก</th>
                        <th className="text-center w-150px">สถานะ</th>
                        <th className="text-center">รายละเอียด</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data &&
                        data.data &&
                        data.data.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {item.rec_in_date
                                ? item.rec_in_date.slice(8, 10) +
                                  " " +
                                  month_array[
                                    Number(item.rec_in_date.slice(5, 7))
                                  ] +
                                  " " +
                                  (Number(item.rec_in_date.slice(0, 4)) + 543)
                                    .toString()
                                    .slice(-2) +
                                  " , " +
                                  item.rec_in_time +
                                  " น."
                                : " - "}
                            </td>
                            <td>{item.visitor_card_number}</td>
                            <td>
                              {item.visitor_type === "visit"
                                ? "เยี่ยม"
                                : "เฝ้า"}
                            </td>
                            <td>{item.room_number}</td>
                            <td>
                              {item.rec_in_date
                                ? item.rec_in_date.slice(8, 10) +
                                  " " +
                                  month_array[
                                    Number(item.rec_in_date.slice(5, 7))
                                  ] +
                                  " " +
                                  (Number(item.rec_in_date.slice(0, 4)) + 543)
                                    .toString()
                                    .slice(-2) +
                                  " , " +
                                  item.rec_in_time +
                                  " น."
                                : " - "}
                            </td>
                            <td>
                              {item.datetime_out
                                ? item.datetime_out.slice(8, 10) +
                                  " " +
                                  month_array[
                                    Number(item.datetime_out.slice(5, 7))
                                  ] +
                                  " " +
                                  (Number(item.datetime_out.slice(0, 4)) + 543)
                                    .toString()
                                    .slice(-2) +
                                  " , " +
                                  item.datetime_out.split(" ")[1] +
                                  " น."
                                : " - "}
                            </td>
                            <td className="text-center">
                              <span
                                className={
                                  item.status === 1
                                    ? "status bg-orenge"
                                    : "status bg-blue-light"
                                }
                              >
                                {item.status === 1
                                  ? "อยู่ในพื้นที่"
                                  : "ออกนอกพื้นที่"}
                              </span>
                            </td>
                            <td className="text-center">
                              <button
                                className="btn btn-link"
                                onClick={() => {
                                  this.GETDetail(
                                    item.rec_in_date,
                                    item.rec_in_time,
                                    index
                                  )
                                }}
                              >
                                <span className="icon mr-2">{"\uf06e"}</span>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* pagination */}
            {data && data.data.length !== 0 && (
              <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                <div>
                  <span>
                    แสดง {data.end_index} จาก {data.count}{" "}
                    รายการ
                  </span>
                </div>
                <div className="d-flex">
                  <button
                    className="btn-circle-white mx-1"
                    onClick={() => {
                      this.handlePageChange(1)
                    }}
                  >
                    <span className="icon">{"\uf100"}</span>
                  </button>
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={10}
                    totalItemsCount={data.count}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                    prevPageText={<span className="icon">{"\uf104"}</span>}
                    nextPageText={<span className="icon">{"\uf105"}</span>}
                    hideFirstLastPages={true}
                  />
                  <button
                    className="btn-circle-white mx-1"
                    onClick={() => {
                      this.handlePageChange(data.page_number)
                    }}
                  >
                    <span className="icon">{"\uf101"}</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* modal */}
        <div className={modal_detail ? "show-modal" : "hide-modal"}>
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.setState({ modal_detail: false })
            }}
          ></div>
          <div
            className={
              modal_detail ? "box-modal p-4" : "hide-box-modal p-4"
            }
          >
            {/* ปุ่มปิด */}
            <div className="w-100">
              <button
                className="btn btn-link d-block d-md-none ml-auto"
                onClick={() => {
                  this.setState({ modal_detail: false })
                }}
              >
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>
            {/* วันที่นำเข้า - เวลานำเข้า */}
            <div className="d-flex justify-content-around align-items-center">
              <div className="w-50 text-center">
                <span className="icon text-secondary mr-2 text-24">
                  {"\uf133"}
                </span>
                <br />
                {detail && (
                  <b>
                    {detail.rec_in_date.slice(8, 10) +
                      " " +
                      month_array[
                        Number(detail.rec_in_date.slice(5, 7))
                      ] +
                      " " +
                      (Number(detail.rec_in_date.slice(0, 4)) + 543)
                        .toString()
                        .slice(-2)}
                  </b>
                )}
                <br />
                <span className="text-secondary">วันที่นำเข้า</span>
              </div>
              <div className="line-secondary"></div>
              <div className="w-50 text-center">
                <span className="icon text-secondary mr-2 text-24">
                  {"\uf017"}
                </span>
                <br />
                <b>{detail && detail.rec_in_time} น.</b>
                <br />
                <span className="text-secondary">เวลานำเข้า</span>
              </div>
            </div>
            <hr />
            {/* ข้อมูลคนเข้า */}
            {detail &&
              detail.client_data_list.map((item, index) => (
                <>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    key={index}
                  >
                    <div className="d-flex align-items-center">
                      {item.client_picture ? (
                        <div className="user-image mr-3">
                          <img
                            className="user-image"
                            alt="tag"
                            src={item.client_picture}
                          ></img>
                        </div>
                      ) : (
                        <div className="mr-3 user-no-image text-center">
                          <span className="icon text-secondary">
                            {"\uf406"}
                          </span>
                        </div>
                      )}

                      <div>
                        <b className="w-150px">
                          {item.client_full_name ? item.client_full_name : "-"}
                        </b>
                        <br />
                        <label className="text-secondary">
                          {"เลขที่บัตร Visitor: " + item.visitor_card_number
                            ? item.visitor_card_number
                            : "-"}
                        </label>
                      </div>
                    </div>
                    <div
                      className="d-flex pointer"
                      onClick={() => {
                        this.setState({
                          modal_profile: true,
                          profile: item,
                        })
                      }}
                    >
                      <span
                        className={
                          item.status === 1
                            ? "status bg-orenge"
                            : "status bg-blue-light"
                        }
                      >
                        {item.status === 1 ? "อยู่ในพื้นที่" : "ออกนอกพื้นที่"}
                      </span>
                      <span className="icon text-secondary ml-3 text-20 pointer">
                        {"\uf054"}
                      </span>
                    </div>
                  </div>
                  <hr />
                </>
              ))}
            {/* ประเภท */}
            <div className="d-flex justify-content-between mb-2">
              <span className="text-secondary">ประเภท:</span>
              <span className="w-75 text-right">
                {detail && detail.visitor_type === "visit"
                  ? "เยี่ยม"
                  : "เฝ้า"}
              </span>
            </div>
            {/* หมายเลขห้อง */}
            <div className="d-flex justify-content-between mb-2">
              <span className="text-secondary">หมายเลขห้อง:</span>
              <span className="w-75 text-right">
                {detail && detail.room_number
                  ? detail.room_number
                  : "-"}
              </span>
            </div>
            <hr />
            {/* หมายเหตุ */}
            <div className="d-flex justify-content-between my-2">
              <span className="text-secondary">หมายเหตุ:</span>
              <span className="w-75 text-right">
                {detail && detail.remark
                  ? detail.remark
                  : "-"}
              </span>
            </div>
          </div>
        </div>
        {/* modal profile */}
        <div className={modal_profile ? "show-modal" : "hide-modal"}>
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.setState({ modal_profile: false })
            }}
          ></div>
          <div
            className={
              modal_profile ? "box-modal p-4" : "hide-box-modal p-4"
            }
          >
            {/* ปุ่มปิด */}
            <div className="w-100 mb-3">
              <button
                className="btn btn-link align-items-center justify-content-center"
                onClick={() => {
                  this.setState({ modal_profile: false })
                }}
              >
                <span className="icon mr-2 text-24">{"\uf060"}</span>ย้อนกลับ
              </button>
            </div>

            <hr />
            {profile ? (
              <div>
                {/* รูปถ่าย */}
                <div className="d-flex justify-content-between align-items-center my-2">
                  <span className="text-secondary">รูปถ่าย:</span>

                  {profile.client_picture ? (
                    <div className="user-image-big">
                      <img
                        className="user-image-big"
                        alt="tag"
                        src={profile.client_picture}
                      ></img>
                    </div>
                  ) : (
                    <div className="mr-3 user-no-image-big text-center ">
                      <span className="icon text-secondary text-20">
                        {"\uf406"}
                      </span>
                    </div>
                  )}
                </div>
                <hr />
                {/* สถานะ */}
                <div className="d-flex justify-content-between align-items-center my-2">
                  <span className="text-secondary">สถานะ:</span>
                  <span
                    className={
                      profile.status === 1
                        ? "status bg-orenge"
                        : "status bg-blue-light"
                    }
                  >
                    {profile.status === 1
                      ? "อยู่ในพื้นที่"
                      : "ออกนอกพื้นที่"}
                  </span>
                </div>
                {/* เลขที่บัตร Visitor */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">เลขที่บัตร Visitor:</span>
                  <span>
                    {profile.visitor_card_number
                      ? profile.visitor_card_number
                      : "-"}
                  </span>
                </div>

                {/* หมายเลขบัตรประชาชน */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">หมายเลขบัตรประชาชน:</span>
                  <span>
                    {profile.client_id_card
                      ? profile.client_id_card
                      : "-"}
                  </span>
                </div>
                {/* ชื่อ-นามสกุล */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">ชื่อ-นามสกุล:</span>
                  <span>
                    {profile.client_full_name
                      ? profile.client_full_name
                      : "-"}
                  </span>
                </div>
                <hr />

                {/* วันเวลาเข้า */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">วันเวลาเข้า:</span>
                  <span className="w-75 text-right">
                    {profile.rec_in_date
                      ? profile.rec_in_date.slice(8, 10) +
                        " " +
                        month_array[
                          Number(profile.rec_in_date.slice(5, 7))
                        ] +
                        " " +
                        (
                          Number(profile.rec_in_date.slice(0, 4)) +
                          543
                        )
                          .toString()
                          .slice(-2) +
                        ", " +
                        profile.rec_in_time +
                        " น."
                      : " - "}
                  </span>
                </div>

                {/* วันเวลาออก */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">วันเวลาออก:</span>
                  <span className="w-75 text-right">
                    {profile.datetime_out
                      ? profile.datetime_out.slice(8, 10) +
                        " " +
                        month_array[
                          Number(profile.datetime_out.slice(5, 7))
                        ] +
                        " " +
                        (
                          Number(profile.datetime_out.slice(0, 4)) +
                          543
                        )
                          .toString()
                          .slice(-2) +
                        ", " +
                        profile.datetime_out.split(" ")[1] +
                        " น."
                      : "-"}
                  </span>
                </div>
                <hr />

                {/* ผู้นำเข้า */}
                <div className="d-flex justify-content-between my-2">
                  <label className="text-secondary">ผู้นำเข้า:</label>
                  <label className="w-75 text-right">
                    {profile.rec_data_in_by
                      ? profile.rec_data_in_by
                      : "-"}
                  </label>
                </div>
                {/* ผู้นำออก */}
                <div className="d-flex justify-content-between mb-2">
                  <label className="text-secondary">ผู้นำออก:</label>
                  <label className="w-75 text-right">
                    {profile.rec_data_out_by
                      ? profile.rec_data_out_by
                      : "-"}
                  </label>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}
